import * as actions from "./actionTypes";
import * as config from "config";
import ObjectToQueryString from 'utils/ObjectToQueryString';


export function getPayrollMetrics(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetPayrollMetrics + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_METRICS_START,
            onSuccess: actions.GET_PAYROLL_METRICS,
            onError: actions.GET_PAYROLL_METRICS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getAllPayroll(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllPayroll + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_ALL_PAYROLL_START,
            onSuccess: actions.GET_ALL_PAYROLL,
            onError: actions.GET_ALL_PAYROLL_FAILED,
            // useLoginJwt: false,
        },
    }
}


export function downloadGetAllPayroll(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllPayroll + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_GET_ALL_PAYROLL_START,
            onSuccess: actions.DOWNLOAD_GET_ALL_PAYROLL,
            onError: actions.DOWNLOAD_GET_ALL_PAYROLL_FAILED,
        },
    }
}

export function getCurrentPayroll(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll,
            method: "post",
            data: params,
            onStart: actions.GET_CURRENT_PAYROLL_START,
            onSuccess: actions.GET_CURRENT_PAYROLL,
            onError: actions.GET_CURRENT_PAYROLL_FAILED,
        },
    }
}

export function getCurrentPayrollBulk(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll,
            method: "post",
            data: params,
            onStart: actions.GET_CURRENT_PAYROLL_BULK_START,
            onSuccess: actions.GET_CURRENT_PAYROLL_BULK,
            onError: actions.GET_CURRENT_PAYROLL_BULK_FAILED,
        },
    }
}

export function getPayrollDashboardInfo(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/dash-info",
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_DASHBOARD_INFO_START,
            onSuccess: actions.GET_PAYROLL_DASHBOARD_INFO,
            onError: actions.GET_PAYROLL_DASHBOARD_INFO_FAILED,
        },
    }
}

export function getPayrollStatus(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/status",
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_STATUS_START,
            onSuccess: actions.GET_PAYROLL_STATUS,
            onError: actions.GET_PAYROLL_STATUS_FAILED,
        },
    }
}

export function getTransactions(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/transactions?populate=employee&" + ObjectToQueryString(params, ""),
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.GET_PAYROLL_TRANSACTIONS,
            onError: actions.GET_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function downloadGetTransactions(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/transactions?populate=employee&" + ObjectToQueryString(params, ""),
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.DOWNLOAD_PAYROLL_TRANSACTIONS,
            onError: actions.DOWNLOAD_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function getCompletedTransactions(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/transactions?populate=employee&" + ObjectToQueryString(params, ""),
            method: "get",
            data: {},
            onStart: actions.GET_COMPLETED_PAYROLL_TRANSACTIONS_START,
            onSuccess: actions.GET_COMPLETED_PAYROLL_TRANSACTIONS,
            onError: actions.GET_COMPLETED_PAYROLL_TRANSACTIONS_FAILED,
        },
    }
}

export function fetchPayrolls(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiFetchPayroll + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.GET_FETCH_PAYROLLS_START,
            onSuccess: actions.GET_FETCH_PAYROLLS,
            onError: actions.GET_FETCH_PAYROLLS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function downloadFetchPayrolls(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiFetchPayroll + ObjectToQueryString(params),
            method: "get",
            data: {},
            onStart: actions.DOWNLOAD_FETCH_PAYROLLS_START,
            onSuccess: actions.DOWNLOAD_FETCH_PAYROLLS,
            onError: actions.DOWNLOAD_FETCH_PAYROLLS_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getPayrollById(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id,
            method: "get",
            data: {},
            onStart: actions.GET_PAYROLL_BY_ID_START,
            onSuccess: actions.GET_PAYROLL_BY_ID,
            onError: actions.GET_PAYROLL_BY_ID_FAILED,
        },
    }
}

export function runPayroll(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/run",
            method: "post",
            data: {},
            onStart: actions.RUN_PAYROLL_START,
            onSuccess: actions.RUN_PAYROLL,
            onError: actions.RUN_PAYROLL_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function retryPayroll(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiRetryPayroll + id + "/retry",
            method: "post",
            data: {},
            onStart: actions.RETRY_PAYROLL_START,
            onSuccess: actions.RETRY_PAYROLL,
            onError: actions.RETRY_PAYROLL_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function schedulePayroll(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiGetPayroll + id + "/schedule",
            method: "post",
            data: params,
            onStart: actions.SCHEDULE_PAYROLL_START,
            onSuccess: actions.SCHEDULE_PAYROLL,
            onError: actions.SCHEDULE_PAYROLL_FAILED,
            // useLoginJwt: false,
        },
    }
}


export function updatePayrollTransactionStart() {
    return {
        type: actions.UPDATE_PAYROLL_TRANSACTION_START,
        payload: {},
    }
}

export function updatePayrollTransaction(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            baseUrl: config.apiPayrollBaseUrl,
            url: config.apiUpdatePayrollTransaction + id,
            method: "put",
            data: params,
            onSuccess: actions.UPDATE_PAYROLL_TRANSACTION_SUCCESS,
            onError: actions.UPDATE_PAYROLL_TRANSACTION_FAILED,
        },
    }
}

export function updatePayrollTransactionReset() {
    return {
        type: actions.UPDATE_PAYROLL_TRANSACTION_RESET,
        payload: {},
    }
}
